<template>
  <!-- eslint-disable max-len -->
  <div class="configuration-wizard-lets-go">
    <mj-configuratin-wizard-header>
      <template #headline>
        Yay, die Konfiguration ist abgeschlossen
      </template>
      <template #info-text>
        Spitze! Du hast die ersten Schritte erfolgreich absolviert. Du kannst jetzt sofort damit beginnen,
        deine Playlist zu befüllen und deinen Gästezugang zu teilen. Zusammen feiert es sich einfach besser.
      </template>
      <template #progress-bar>
        <mj-configuratin-wizard-progress-bar
          :current-step="3"
          :labels="progressLabels"
        />
      </template>
    </mj-configuratin-wizard-header>
    <mj-configuratin-wizard-content>
      <div class="flex w-full justify-center text-center">
        <router-link
          tag="mj-button"
          class="btn-primary"
          :to="{ name: 'event.track.search'}"
        >
          Playlist befüllen
        </router-link>
      </div>
      <div class="flex w-full mt-12">
        <mj-icon
          src="wizard"
          class="w-full h-auto"
          proportions="rectangle"
        />
      </div>
    </mj-configuratin-wizard-content>
  </div>
</template>

<script>
import ConfigurationWizardHeader from '@/components/configuration-wizard/ConfigurationWizardHeader.vue';
import ConfigurationWizardContent from '@/components/configuration-wizard/ConfigurationWizardContent.vue';
import ConfigurationWizardProgressBar from '@/components/configuration-wizard/ConfigurationWizardProgressBar.vue';

export default {
  name: 'ConfigurationWizardLetsGo',

  components: {
    'mj-configuratin-wizard-header': ConfigurationWizardHeader,
    'mj-configuratin-wizard-content': ConfigurationWizardContent,
    'mj-configuratin-wizard-progress-bar': ConfigurationWizardProgressBar,
  },

  data() {
    return {
      form: {
        eventName: null,
        eventDate: null,
      },

      progressLabels: [
        { name: '1. Spotify autorisieren', isActive: false, isComplete: true },
        { name: '2. Event erstellen', isActive: false, isComplete: true },
        { name: '3. Los gehts', isActive: true, isComplete: false },
      ],

    };
  },

};

</script>
